define('app/views/anchored-image',['require'],function(require){

  var DEFAULTS = {
    mode: 'crop',
    anchor: 5,
    autoResize: true,
    useBackgroundSize: true,
    resizeThrottle: 250
  };

  return Backbone.View.extend({

    image: null,

    initialize: function(options){
      Backbone.View.prototype.initialize.call(this, options);

      _.bindAll(this, 'onResize');

      this.options = _.extend({}, DEFAULTS, (options.setup || {}));

      this.$el.addClass('anchor-' + this.options.anchor);

      this.image = $('> img', this.$el);

      var _self = this;

      this.image.one('load', function(){
        _self.$el.css({ 'background-image': 'url("' + _self.image.attr('src') + '")' });
        _self.$el.addClass('loaded');
        _self.onResize();
      });

      if(this.image.get(0).complete){
        this.image.load();
      }

      if(this.options.autoResize){
        $(window).resize(_.throttle(this.onResize, this.options.resizeThrottle, { trailing: false }));
        this.$el.on('mouseenter', this.onResize);
      }
    },

    crop: function(w, h, img){
      var iw = img.width();
      if (iw!= w) {
        img.width(w);
        img.css('height', 'auto');
      }

      var ih = img.height();
      if (ih < h) {
        img.height(h);
        img.css('width', 'auto');
      }

      var left = (w - img.width()) / 2;
      var top = (h - img.height()) / 2;

      img.css({ top: top, left: left });

      this.anchor[this.options.anchor].call(this, w, h);
    },

    fit: function(w, h, img){
    },

    anchor: [
      function(w, h){},

      //top left
      function(){
        this.image.css({ top: 0, left: 0 });
      },

      //top center
      function(w){
        var left = (w - this.image.width()) / 2;
        this.image.css({ top: 0, left: left });
      },

      //top right
      function(){
        this.image.css({ top: 0, right: 0 });
      },

      //left center
      function(h){
        var top = (h - this.image.height()) / 2;
        this.image.css({ top: top, left: 0 });
      },

      //center center
      function(w, h){
        var left = (w - this.image.width()) / 2;
        var top = (h - this.image.height()) / 2;
        this.image.css({ top:top, left:left });
      },

      //right center
      function(w, h){
        var top = (h - this.image.height()) / 2;
        this.image.css({ top: top, right: 0 });
      },

      //left bottom
      function(){
        this.image.css({ bottom: 0, left: 0 });
      },

      //center bottom
      function(w){
        var left = (w - this.image.width()) / 2;
        this.image.css({ bottom: 0, left: left });
      },

      //right bottom
      function(){
        this.image.css({ bottom: 0, right: 0 });
      }
    ],

    onResize: function(e){
      if(this.image.is(':visible')) {
        if(this[this.options.mode]){
          this[this.options.mode].call(this, this.$el.width(), this.$el.height(), this.image);
        } else {
          console.log('no resize function for mode: ' + this.options.mode);
        }
      }
    }

  });

});
